import { Suspense } from "react";
import "./global.css";
import { Toaster } from "react-hot-toast";
import { useScrollToTop } from "./hooks/use-scroll-to-top";
import Router from "./router";
import ThemeProvider from "./theme";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import BarcodeScanner from 'src/components/BarcodeScanner';

// ----------------------------------------------------------------------

export default function App() {
  useScrollToTop();

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <ThemeProvider>
        <Toaster position="top-center" reverseOrder={false} />
          <BarcodeScanner />
        <Suspense>
          <Router />
        </Suspense>
      </ThemeProvider>
    </LocalizationProvider>
  );
}
